var divider_viewer_rtlignore_default = {
  "divider-container": "BREeK",
  "divider-container--double": "Hhqkf",
  "divider": "ixFlP",
  "divider--single": "jadp7",
  "divider--double": "t-2Qs",
  "divider--dashed": "_7qQTT",
  "divider--dotted": "_0H7Kv",
  "divider--small": "yO8Z8",
  "divider--medium": "xWlva",
  "divider--large": "grqiU",
  "divider--left": "QcWjo",
  "divider--center": "_5MBF-",
  "divider--right": "YkyI5",
  "svgFixerContainer": "F7RE1",
  "emptyChar": "hn47y"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
